module.exports = __webpack_public_path__ + "static/a-d3b8b8e6892a581c541430443452b013.png";